import script from "./projectCreation.vue?vue&type=script&lang=ts&setup=true"
export * from "./projectCreation.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__